import { createRouter, createWebHashHistory } from 'vue-router'

export const routes = [
  {
    path: '/login',
    name: 'login',
    id: 'login',
    meta: {
      hiddenMenu: true,
      hiddenLayout: true
    },
    component: () => import('@/views/login.vue')
  },
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'home',
    id: 'home',
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/house-sale-list',
    name: 'shh',
    id: 'shHouseList',
    component: () => import('@/views/shHouseList.vue')
  },
  {
    path: '/house-sale-detail',
    name: 'shd',
    id: 'shHouseDetail',
    component: () => import('@/views/shHouseDetail.vue')
  },
  {
    path: '/building-list',
    name: 'buildingList',
    id: 'buildingList',
    component: () => import('@/views/buildingList.vue')
  },
  {
    path: '/building-photo',
    name: 'buildingPhoto',
    id: 'buildingPhoto',
    component: () => import('@/views/buildingPhotos.vue')
  },
  {
    path: '/building-detail',
    name: 'buildingDetail',
    id: 'buildingDetail',
    component: () => import('@/views/buildingDetail.vue')
  },
  {
    path: '/store-transfer-list',
    name: 'storeTransfer',
    id: 'storeTransfer',
    component: () => import('@/views/storeTransfer.vue')
  },
  {
    path: '/store-transfer-detail',
    name: 'storeTransferDetail',
    id: 'storeTransferDetail',
    component: () => import('@/views/storeTransferDetail.vue')
  },
  {
    path: '/house-rental-list',
    name: 'houseRentalList',
    id: 'houseRentalList',
    component: () => import('@/views/houseRental.vue')
  },
  {
    path: '/house-rental-detail',
    name: 'houseRentalDetail',
    id: 'houseRentalDetail',
    component: () => import('@/views/houseRentalDetail.vue')
  },
  {
    path: '/store-rental-list',
    name: 'stroreRentalList',
    id: 'stroreRentalList',
    component: () => import('@/views/storeRental.vue')
  },
  {
    path: '/store-rental-detail',
    name: 'stroreRentalDetail',
    id: 'stroreRentalDetail',
    component: () => import('@/views/storeRentalDetail.vue')
  },
  {
    path: '/store-sale-list',
    name: 'stroreSaleList',
    id: 'stroreSaleList',
    component: () => import('@/views/storeSale.vue')
  },
  {
    path: '/store-sale-detail',
    name: 'stroreSaleDetail',
    id: 'stroreSaleDetail',
    component: () => import('@/views/storeSaleDetail.vue')
  },
  {
    path: '/factory-sale',
    name: 'factorySale',
    id: 'factorySale',
    component: () => import('@/views/factorySale.vue')
  },
  {
    path: '/factory-sale-detail',
    name: 'factorySaleDetail',
    id: 'factorySaleDetail',
    component: () => import('@/views/factorySaleDetail.vue')
  },
  {
    path: '/factory-rental-list',
    name: 'factoryRental',
    id: 'factoryRental',
    component: () => import('@/views/factoryRental.vue')
  },
  {
    path: '/factory-rental-detail',
    name: 'factoryRentalDetail',
    id: 'factoryRentalDetail',
    component: () => import('@/views/factoryRentalDetail.vue')
  },
  {
    path: '/land-transfer',
    name: 'landTransfer',
    id: 'landTransfer',
    component: () => import('@/views/landTransfer.vue')
  },
  {
    path: '/land-transfer-detail',
    name: 'landTransferDetail',
    id: 'landTransferDetail',
    component: () => import('@/views/landTransferDetail.vue')
  },
  {
    path: '/land-rental',
    name: 'landRental',
    id: 'landRental',
    component: () => import('@/views/landRental.vue')
  },
  {
    path: '/land-rental-detail',
    name: 'landRentalDetail',
    id: 'landRentalDetail',
    component: () => import('@/views/landRentalDetail.vue')
  },
  {
    path: '/content-list',
    name: 'contentList',
    id: 'contentList',
    component: () => import('@/views/content.vue')
  },
  {
    path: '/content-detail',
    name: 'contentDetail',
    id: 'contentDetail',
    component: () => import('@/views/contentDetail.vue')
  },
  {
    path: '/join-vip',
    name: 'joinVip',
    id: 'joinVip',
    component: () => import('@/views/joinVip.vue')
  },
]

const router = createRouter({
  // mode: 'history',
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0 }
  },
})

router.beforeEach(
  async (
    to,
    from,
    next
  ) => {
    const blackList = []
    if (to.name && blackList.length && to.name.indexOf(blackList) > -1) {
      window.location.href='/#/404'
    } else {
      next()
    }
  }
);


export default router
